
import { Paper } from '@mui/material';
import * as React from 'react';
import NavigationBar from '../../components/navigation/Navigation';
import Sidebar from '../../components/sidebar/Sidebar';
import { Outlet } from 'react-router';
import './home.scss';

import fetchIntercept from 'fetch-intercept';
import QuickActions from '../../components/common/QuickActions';

// Configuration de l'intercepteur (vérification pour éviter double register)
if (!window.fetchInterceptorRegistered) {
    fetchIntercept.register({
        request: function (url, config) {
            if (!config.headers) {
                config.headers = {};
            }
            if (!url.includes('test_auth.php') && !url.includes('/auth')) {
                const token = localStorage.getItem('token');
                if (token) config.headers.Authorization = `Bearer ${token}`;
            }
            return [url, config];
        },
        requestError: function (error) {
            return Promise.reject(error);
        },
        response: function (response) {
            return response;
        },
        responseError: function (error) {
            return Promise.reject(error);
        }
    });
    window.fetchInterceptorRegistered = true;
}

const styles = {
    appContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden'
    },
    navbar: {
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        height: '50px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    mainLayout: {
        display: 'flex',
        marginTop: '50px',
        height: 'calc(100vh - 50px)',
        overflow: 'hidden'
    },
    sidebar: {
        position: 'fixed',
        left: 0,
        top: '50px',
        width: '320px',
        height: 'calc(100vh - 50px)',
        zIndex: 999,
        transition: 'transform 0.3s ease-in-out',
        transform: 'translateX(0)',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    sidebarHidden: {
        transform: 'translateX(-100%)'
    },
    content: {
        marginLeft: '320px',
        width: 'calc(100% - 320px)',
        height: '100%',
        overflow: 'auto',
        padding: '15px',
        transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out'
    },
    contentExpanded: {
        marginLeft: 0,
        width: '100%'
    }
}

const HomePage = (props) => {
    const [sidebar, setSideBar] = React.useState(2);
    const isSidebarVisible = sidebar === 2;

    return <div className='App' style={styles.appContainer}>
        {/* Navbar fixe */}
        <div style={styles.navbar}>
            <NavigationBar onHambergerClick={() => setSideBar(sidebar === 2 ? 0 : 2)} />
        </div>

        {/* Layout principal */}
        <div style={styles.mainLayout}>
            {/* Sidebar fixe */}
            <div style={{
                ...styles.sidebar,
                ...(isSidebarVisible ? {} : styles.sidebarHidden)
            }}>
                <Paper elevation={3} style={{
                    height: '100%',
                    borderRadius: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}>
                    <Sidebar />
                </Paper>
            </div>

            {/* Zone de contenu scrollable */}
            <div style={{
                ...styles.content,
                ...(isSidebarVisible ? {} : styles.contentExpanded)
            }}>
                <Outlet />
                <QuickActions />
            </div>
        </div>
    </div>
}

export default HomePage;
